import contentPathUrlMapper from '../src/utils/contentURLMapper';
import Head from 'next/head';

import ESI from '../src/components/ESI';
import logControl from '../src/utils/logger-utils/logControl';

function Content({ url, query }) {
  const path = query.path ? query.path : 'home';
  const contentPath = contentPathUrlMapper(url, false);
  return (
    <>
      <Head>
        <title>
          John Lewis & Partners | Homeware, Fashion, Electricals & More
        </title>
        <meta
          name="description"
          content="Shop new season trends in homeware, furniture and fashion at John Lewis & Partners. Discover the latest beauty products and browse must-have electricals, including iPads and TVs. Find gifts and much more at johnlewis.com"
        />
        <link rel="canonical" href="https://www.johnlewis.com/" />
        <meta property="og:url" content="https://www.johnlewis.com/" />
        <meta
          property="og:title"
          content="John Lewis & Partners | Homeware, Fashion, Electricals & More"
        />
        <meta
          property="og:description"
          content="Shop new season trends in homeware, furniture and fashion at John Lewis & Partners. Discover the latest beauty products and browse must-have electricals, including iPads and TVs. Find gifts and much more at johnlewis.com"
        />
        <meta
          property="og:image"
          content="https://johnlewis.scene7.com/is/image/JohnLewis/ogFeatureImage-johnLewisPartners-040918"
        />
      </Head>
      <ESI src={contentPath} id={`content-renderer-${path}`} />
    </>
  );
}

export async function getServerSideProps(context) {
  const { resolvedUrl, query, req } = context;
  logControl(context);

  return {
    props: {
      url: resolvedUrl,
      query,
    },
  };
}

export default Content;
